export default __webpack_public_path__ + "static/media/eho.4945722c.webp";